// extracted by mini-css-extract-plugin
export default {"cls1":"NbQfV7cDxemFbaSuFEaA","cls2":"_pl408PchsRo4WTuHFgl NbQfV7cDxemFbaSuFEaA"};